<style lang="less" scoped>
  .category-content {
    padding: 0 10px;
  }
  .container {
    display: inline-block;
  }
  .show-recent-btn{
    float: right;
  }
  .allot-form{
    .ivu-form-item {
      margin-bottom: 5px;
    }
    .value{
      padding-left: 8px;
    }
  }
</style>
<template>
  <div
    ref="container"
    class="container"
    @dragenter="dragenter"
    @dragleave="dragleave"
    @dragover.prevent="dragover"
    @drop="drop"
  >
    <Button
      icon="md-link"
      :size="size"
      :loading="loading"
      :type="drag_entered ? 'primary' : 'default'"
      @click="edit()"
    >
      关联发票
    </Button>

    <VModal
      v-model="config.modal"
      title="关联发票"
      transfer
      width="900"
      dynamic-height
      :height-rate="0.9"
      :mask-closable="false"
      cancel-text=""
      ok-text="关闭"
      @ok="cancel"
    >
      <div class="line">
        <h3>上传发票文件:</h3>
        <FileUploader
          :multiple="false"
          :data="{id: model_id}"
          :max_size="1024*8"
          :upload_path="ocr_invoice_path"
          @done="ocrDone"
        />
      </div>
      <div
        v-if="category_detail_list&&category_detail_list.length"
        class="line"
      >
        <h3>已经提供发票:</h3>
        <div
          v-for="(detail, index) in category_detail_list"
          :key="`${index}_${$util.guid()}`"
        >
          <div class="text-bold">
            {{ index+1 }}. {{ categoryName(detail.category_id) }}
          </div>
          <div class="category-content">
            <v-row>
              <v-col md="3">
                类别金额:
                ￥{{ $util.formatPrice(detail.amount) }}
              </v-col>
              <v-col md="3">
                纸票数量:
                {{ $util.formatNumber(detail.paper_invoice_count) }}
              </v-col>
              <v-col md="3">
                替票数量:
                {{ $util.formatNumber(detail.sub_invoice_count) }}
              </v-col>
              <v-col md="3">
                替票金额:
                ￥{{ $util.formatPrice(detail.sub_invoice_amount) }}
              </v-col>
            </v-row>
            <div
              v-if="detail.rough_invoices.length"
            >
              <RoughInvoice
                v-for="rough_invoice in detail.rough_invoices"
                :key="rough_invoice.id"
                :show-link="false"
                :show-check-box="false"
                :invoice="rough_invoice"
                @preview="preview"
                @link="linkInvoice"
              />
            </div>
            <div
              v-else
              class="color-grey"
            >
              无上传发票
            </div>
          </div>
        </div>
      </div>
      <div class="line">
        <h3>
          已关联发票:
          <Button
            size="small"
            type="primary"
            @click="allotmentMoney()"
          >
            一键分配金额
          </Button>
        </h3>
        <Table
          size="small"
          :columns="selected_columns"
          :data="invoices"
        />
      </div>
      <div class="line">
        <Button
          v-if="default_invoices.none"
          size="small"
          type="warning"
          :disabled="isInInvoices(default_invoices.none)"
          @click="addInvoice(default_invoices.none)"
        >
          无发票
        </Button>
        <Button
          v-if="default_invoices.tmp_none"
          size="small"
          type="warning"
          :disabled="isInInvoices(default_invoices.tmp_none)"
          @click="addInvoice(default_invoices.tmp_none)"
        >
          暂无发票
        </Button>
        <!--                <Button size="small" type="warning" @click="addInvoice(default_invoices.inner)" :disabled="isInInvoices(default_invoices.inner)" v-if="default_invoices.inner">内部凭证</Button>-->
      </div>
      <div class="hr" />
      <i-input
        v-model="params.search"
        placeholder="搜索发票"
        @on-enter="search"
      >
        <Button
          slot="append"
          icon="ios-search"
          :loading="searching"
          @click="search"
        >
          搜索
        </Button>
      </i-input>
      <div
        v-if="search_invoices.length"
        class="line"
      >
        <div class="line">
          <h3>
            搜索结果: <Button
              class="show-recent-btn"
              size="small"
              @click="showRecent"
            >
              查看最近添加的发票
            </Button>
          </h3>
        </div>
        <Table
          size="small"
          :columns="search_columns"
          :data="search_invoices"
        />
      </div>
      <div
        v-else
        class="line"
      >
        <h3>最近添加的发票:</h3>
        <Table
          size="small"
          :columns="search_columns"
          :data="recent_invoices"
        />
      </div>
      <Spin
        v-if="adding || deleting"
        fix
      />
    </VModal>

    <VModal
      v-model="allot_config.modal"
      title="分配金额"
      dynamic-height
      :height-rate="0.7"
      width="500"
      :mask-closable="false"
      :loading="allot_config.loading"
      ok-text="保存"
      @ok="allotDone"
    >
      <Form
        class="allot-form"
        :label-width="80"
      >
        <FormItem label="发票代码">
          <div class="value">
            {{ edit_invoice.code || '-' }}
          </div>
        </FormItem>
        <FormItem label="发票号码">
          <div class="value">
            {{ edit_invoice.uid || '-' }}
          </div>
        </FormItem>
        <FormItem label="综合税率">
          <div class="value">
            {{ edit_invoice.tax_rate }}%
          </div>
        </FormItem>
        <FormItem label="发票金额">
          <div class="value">
            {{ formatPrice(edit_invoice.total_price) }}
          </div>
        </FormItem>
        <FormItem label="分配金额">
          <i-input
            v-model="edit_invoice.allot_price"
            placeholder="请输入分配金额"
            style="width: 150px"
            @on-change="calcAllotTax(edit_invoice.allot_price)"
          />
          <Button @click="setTotalPriceToAllotPrice()">
            发票金额
          </Button>
          <Button
            :loading="left_allotting"
            @click="setLeftPriceToAllotPrice"
          >
            发票剩余金额
          </Button>
        </FormItem>
        <FormItem label="发票税额">
          <div class="value">
            {{ formatPrice(edit_invoice.tax) }}
          </div>
        </FormItem>
        <FormItem label="分配税额">
          <i-input
            v-model="edit_invoice.allot_tax"
            placeholder="请输入分配税额"
            style="width: 150px"
          />
          <div
            v-if="!is_edit_special_invoice"
            class="color-grey"
          >
            专票自动计算分配税额，其他类型无需分配。特殊情况请手动填写分配税额
          </div>
        </FormItem>
      </Form>
    </VModal>
  </div>
</template>
<script>
  import VModal from '@/vuetify_custom/v-modal_v1'
  import VRippleCol from '@/vuetify_custom/v-ripple-col';
  import RoughInvoice from '@/views/expense_group/components/rough_invoice.vue';
  import FileUploader from '../../components/file/uploader';
  import InvoiceEditor from '../../invoice/components/invoice_editor';
  import InvoicePicture from './invoice_picture';
  import InvoiceUtil from '../libs/util';
  import { BX_CATEGORY_HASH } from '@/views/expense_group/fields.js'
  export default {
    components: { InvoiceEditor, FileUploader, InvoicePicture, VModal, VRippleCol, RoughInvoice },
    props: {
      model_type: {
        type: String,
        validator: function(type) {
          return type.length > 0;
        }
      },
      model_id: {
        type: Number,
        validator: function(id) {
          return id > 0;
        }
      },
      invoices: {
        type: Array,
        default() {
          return [];
        }
      },
      reimbursement: {
        type: Object
      },
      size: {
        type: String,
        default: 'default'
      }
    },
    data() {
      return {
        category_detail_list: [],
        ocr_invoice_path: this.$util.api.ocr_expense_invoice,
        config: {
          modal: false,
          loading: true
        },
        allot_config: {
          modal: false,
          loading: false
        },
        drag_entered: false,
        params: {
          search: ''
        },
        default_invoices: {
          none: null,
          tmp_none: null,
          inner: null
        },
        invoice_hash: {},
        loading: false,
        recent_invoices: [],
        searching: false,
        search_invoices: [],
        invoice_columns: [
          {
            title: '发票类型',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const type = InvoiceUtil.getInvoiceType(row.invoice_type);
              return h('span', {
                'class': {
                  'color-error': [0, 1, 2].indexOf(row.invoice_type) === -1
                }
              }, type);
            }
          },
          {
            title: '发票代码',
            align: 'center',
            key: 'code'
          },
          {
            title: '发票号码',
            align: 'center',
            key: 'uid'
          },
          {
            title: '发票金额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, this.$util.formatPrice(row.total_price));
            }
          },
          {
            title: '分配金额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, this.$util.formatPrice(row.allot_price));
            }
          },
          {
            title: '发票税额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, this.$util.formatPrice(row.tax));
            }
          },
          {
            title: '分配税额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, this.$util.formatPrice(row.allot_tax));
            }
          },
          {
            title: '综合税率',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', `${row.tax_rate}%`);
            }
          },
          {
            title: '发票文件',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              if (row.invoice_file_id) {
                return h(InvoicePicture, {
                  props: {
                    invoice_id: row.id
                  }
                });
              } else {
                return h('div', '-');
              }
            }
          },
          /*{
                        title: '备注',
                        align: 'center',
                        key: 'desc',
                        render: (h, params) => {
                            let row = params.row;
                            if(row.desc){
                                return h('div', row.desc);
                            }else{
                                return h('span', '-');
                            }
                        }
                    }*/
        ],
        adding: false,
        deleting: false,
        edit_invoice: {},
        allot_price: 0,
        left_allotting: false
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      selected_columns() {
        const columns = this.$util.clone(this.invoice_columns);
        columns.push({
          title: '分配金额',
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('Button', {
              props: {
                size: 'small'
              },
              on: {
                click: () => {
                  this.allotPrice(row, params.index);
                }
              }
            }, '分配');
          }
        });
        columns.push({
          title: '关联时间',
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('div', this.$util.formatDate(row.updated_at));
          }
        });
        columns.push({
          title: '操作',
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('Poptip', {
              props: {
                transfer: true,
                confirm: true,
                title: '你确定要取消关联吗?'
              },
              on: {
                'on-ok': () => {
                  this.delInvoice(row, params.index);
                }
              }
            }, [h('Button', {
              props: {
                size: 'small',
                type: 'warning',
              }
            }, '删除')]);
          }
        });
        return columns;
      },
      search_columns() {
        const columns = this.$util.clone(this.invoice_columns);
        columns.push({
          title: '操作',
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('Button', {
              props: {
                size: 'small',
                type: 'primary',
                disabled: this.isInInvoices(row)
              },
              on: {
                click: () => {
                  this.addInvoice(row);
                }
              }
            }, '关联');
          }
        });
        return columns;
      },
      is_edit_special_invoice() {
        return this.edit_invoice.invoice_type === 1;
      }
    },
    created() {
      this.genInvoiceHash();
    },
    mounted() {
      this.$refs.container.addEventListener('drop', this.drop);
    },
    methods: {
      allotmentMoney() {
        let invoices = JSON.parse(JSON.stringify(this.invoices))
        invoices = invoices.filter(i => i && !Number(i.allot_price))

        invoices.forEach(i => {
          i = i || {}
          const target = this.setTotalPriceToAllotPrice(i)

          this.allotDone(target, true)
        })
        if (!invoices || !invoices.length) {
          this.$Message.warning('所有发票金额已分配！')
        }
      },
      linkInvoice(invoice) {
        // console.log('invoice', invoice)
      },
      preview(invoice = {}) {
        const filepath = invoice.oss_img_path ? invoice.oss_img_path : invoice.oss_pdf_path;
        if (!filepath) {
          this.$Message.error('未找到文件路径，无法预览');
          return;
        }
        const oss_url = this.$util.publicOSSUrl(filepath);
        window.open(oss_url);
      },
      categoryName(category_id) {
        return BX_CATEGORY_HASH[category_id];
      },
      getBillInvoices() {
        const list = [];
        if (this.reimbursement) {
          const { category_detail_list = [] } = this.reimbursement;
          category_detail_list.forEach((detail) => {
            const item = this.$util.clone(detail);
            item.rough_invoices.forEach((rough_invoice) => {
              rough_invoice._checkout = false;
              if (rough_invoice.ocr_status === 'success') {
                const ocr_res = JSON.parse(rough_invoice.ocr_result);
                rough_invoice.ocr_invoice_list = ocr_res['response']['data']['identify_results'].map(_ => _.details);
              }
            });
            list.push(item);
          });
        }
        this.category_detail_list = list
      },
      init() {
        this.getRecentInvoices();
      },
      getRecentInvoices() {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.query_recent_invoice).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            this.recent_invoices = res.data.invoices;
            this.default_invoices.none = data.none;
            this.default_invoices.tmp_none = data.tmp_none;
            this.default_invoices.inner = data.inner;
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      dragenter(ev) {
        this.drag_entered = true;
        console.log(ev.type);
      },
      dragleave(ev) {
        if (ev.target.parentNode === this.$refs.container) {
          return;
        }
        this.drag_entered = false;
        console.log(ev);
      },
      dragover() {},
      drop(ev) {
        ev.stopImmediatePropagation();
        this.drag_entered = false;
        const rough_invoice_str = ev.dataTransfer.getData('rough-invoice');
        if (rough_invoice_str) {
          const rough_invoice = JSON.parse(rough_invoice_str);
          if (rough_invoice.ocr_status === 'success') {
            console.log(rough_invoice);
            this.loading = true;
            this.$util.ajax.post(this.$util.api.add_model_rough_invoice, {
              model_type: this.model_type,
              model_id: this.model_id,
              rough_invoice_id: rough_invoice.id
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                const invoices = res.data.invoices;
                invoices.forEach((invoice) => {
                  this.$util.insertOrUpdateArrayItem(this.invoices, invoice);
                });
                this.genInvoiceHash();
                this.edit();
              } else {
                this.$Modal.warning({title: '错误', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.warning({title: '错误', content: e.message});
            }).finally(() => {
              this.loading = false;
            });
          }
        }
      },
      showRecent() {
        this.search_invoices = [];
      },
      genInvoiceHash() {
        this.invoice_hash = {};
        this.invoices.forEach((i) => {
          this.invoice_hash[i.id] = i;
        });
      },
      isInInvoices(invoice) {
        return !!this.invoice_hash[invoice.id];
      },
      edit() {
        this.config.modal = true;
        this.getRecentInvoices();
        this.getBillInvoices() 
      },
      cancel() {
        this.config.modal = false;
      },
      formatPrice(price) {
        return this.$util.formatPrice(price);
      },
      search() {
        this.searching = true;
        this.$util.ajax.get(this.$util.api.query_invoice, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.searching = false;
          if (res.code === 1) {
            this.search_invoices = res.data.invoices;
            if (this.search_invoices.length === 0) {
              this.$Message.warning('没有搜索到相关发票');
            }
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.searching = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      addInvoice(invoice) {
        this.adding = true;
        this.$util.ajax.post(this.$util.api.add_model_invoice, {
          model_type: this.model_type,
          model_id: this.model_id,
          invoice_id: invoice.id
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.adding = false;
          if (res.code === 1) {
            const expense_invoice = res.data.invoice;
            this.$util.insertOrUpdateArrayItem(this.invoices, expense_invoice);
            this.genInvoiceHash();
            this.$Message.success('关联成功');
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.adding = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      delInvoice(invoice, index) {
        this.deleting = true;
        this.$util.ajax.post(this.$util.api.del_model_invoice, {
          model_type: this.model_type,
          model_id: this.model_id,
          invoice_id: invoice.id
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.deleting = false;
          if (res.code === 1) {
            this.invoices.splice(index, 1);
            this.genInvoiceHash();
            this.$Message.success('取消关联成功');
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.deleting = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      ocrDone(res) {
        if (res.code === 1) {
          this.$emit('update:invoices', res.data.invoices);
        } else {
          this.$Modal.error({title:'提示', content: res.msg});
        }
      },
      allotPrice(invoice) {
        this.edit_invoice = this.$util.clone(invoice);
        this.allot_config.modal = true;
      },
      checkAllotValid() {
        let err_msg = '';
        if (!this.edit_invoice.allot_price) {
          err_msg += `<p>分配金额不能为空</p>`;
        }
        if (!this.$util.isNumber(this.edit_invoice.allot_price)) {
          err_msg += `<p>请填写正确的分配金额格式</p>`;
        } else if (math.eval(`${this.edit_invoice.total_price} < ${this.edit_invoice.allot_price}`)) {
          err_msg += `<p>分配金额不能大于发票金额</p>`;
        }
        if (err_msg) {
          // this.resetAllotLoading();
          this.$Modal.error({title: '错误', content: err_msg});
          return false;
        }
        return true;
      },
      allotDone(edit_invoice = this.edit_invoice, is_all) {
        if (is_all || this.checkAllotValid()) {
          this.allot_config.loading = true;
          // const edit_invoice = this.edit_invoice;
          return this.$util.ajax.post(this.$util.api.allot_invoice_price, edit_invoice).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              this.$util.insertOrUpdateArrayItem(this.invoices, edit_invoice);
              this.allot_config.modal = false;
              if (is_all) {
                this.$Message.success(`发票 ${edit_invoice.code} ，分配金额成功`);
              } else {
                this.$Message.success('分配金额成功');
              }
             
            } else {
              this.$Modal.warning({title: '错误', content: res.msg});
            }
          }).catch((e) => {
            this.$Modal.warning({title: '错误', content: e.message});
          }).finally(() => {
            this.allot_config.loading = false;
          //  this.resetAllotLoading();
          });
        }
        return Promise.reject()
      },
      resetAllotLoading() {
        this.allot_config.loading = false;
        setTimeout(() => {
          this.allot_config.loading = true;
        }, 500);
      },
      setTotalPriceToAllotPrice(target = this.edit_invoice) {
        const total_price = target.total_price;
        target.allot_price = total_price;
        return this.calcAllotTax(total_price, target);
      },
      setLeftPriceToAllotPrice() {
        if (this.left_allotting) return;
        this.left_allotting = true;
        this.$util.ajax.get(this.$util.api.invoice_allot_balance, {
          params: this.edit_invoice
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const balance = res.data.allot_balance;
            this.edit_invoice.allot_price = balance;
            this.calcAllotTax(balance);
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.left_allotting = false;
        });
      },
      calcAllotTax(price, target) {
        target = target || this.edit_invoice
        if (target.invoice_type === 1) {
          // const tax_rate = math.eval(`${this.edit_invoice.tax_rate} / 100`).toFixed(4);
          // this.edit_invoice.allot_tax = math.eval(`${price} / (1 + ${tax_rate}) * ${tax_rate}`).toFixed(2);
          const total_price = math.eval(`${target.total_price} > 0`) ? target.total_price : 1;
          target.allot_tax = math.eval(`${price} / ${total_price} * ${target.tax}`).toFixed(2);
        } else {
          target.allot_tax = 0;
        }
        return target
      }
    }
  }
</script>
